import { Text } from '@dixa/lib-shared-habla';

import { ConversationAutomationAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughThirdPartyIntegrationProps = {
  node: ConversationAutomationAuditLogEntry<'AUTOMATION_THIRD_PARTY_INTEGRATION_NODE_VISITED'>;
};
export function RoutedThroughThirdPartyIntegration({
  node,
}: RoutedThroughThirdPartyIntegrationProps): JSX.Element {
  if (node.outcome?.type === 'error') {
    return (
      <Text.Paragraph>
        Platform action · Failed with error: {node.outcome.error.message}
      </Text.Paragraph>
    );
  }

  return (
    <Text.Paragraph>
      Platform action · Successfully called the platform action
    </Text.Paragraph>
  );
}
